import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Overlay, Popover, Button, Form } from 'react-bootstrap'
import Responsibles from '../Responsibles'
import DateInputField from '../DateInputField'
import ExportButton from '../ExportButton'
import ExportChiefReportButton from '../ExportChiefReportButton'
import { DEPARTMENT_HEADS } from '../../constants/roles'
import ReportsApi from '../../api/ReportsApi'
import { ApiException, ValidationException } from '../../api/exceptions'

const api = new ReportsApi();

const ExportDocumentForm = ({ auth, filters }) => {
  const { user } = auth

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const alert = withReactContent(Swal);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleError = (e) => {
    let message = 'Hubo un problema al procesar la solicitud. Intente de nuevo más tarde.';

    if (e instanceof ApiException) {
      message = e.message;
    } else if (e instanceof ValidationException) {
      message = Object.entries(e.errors).join(' \n')
    }

    alert.fire('Error!', message, 'error');
  }
  
  return (
    <>  
      <Button onClick={handleClick} variant='success'><i className="fa fa-file-excel-o"></i></Button>

      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref.current}
        containerPadding={20}
        transition={true}
      >
        <Popover id="popover-contained">
          <Popover.Title as='h3'><strong>Reportes</strong></Popover.Title>
          <Popover.Content>
            <Form>
              <DateInputField />
              {
                DEPARTMENT_HEADS.includes(user.role) && <Responsibles />
              }
              <ExportButton
                callback={() => api.excel(filters)}
                onError={handleError}
              />
              <ExportChiefReportButton
                title='Generar Concentrado'
                loadingTitle='Generando Concentrado'
                tooltipText='Generar reporte concentrado'
                callback={() => api.concentrated(filters)}
                onError={handleError}
              />
              <ExportChiefReportButton
                title='Alumnos sin Documentación'
                tooltipText='Generar reporte de alumnos sin documentación'
                callback={() => api.pendingDocumentation(filters)}
                onError={handleError}
              />
            </Form>
          </Popover.Content>
        </Popover>
      </Overlay>

      <ExportChiefReportButton
        variant='warning'
        icon={<i className='fa fa-file-zip-o'></i>}
        tooltipText='Descargar Fotos'
        callback={() => api.studentPhotos()}
        onError={handleError}
      />
    </>
   )
}

const mapStateToProps = (state) => {
  return {
    auth : state.auth,
    filters : state.exportDocumentReducer
  }
}

export default connect(mapStateToProps)(ExportDocumentForm)